"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkOnlyFulfilablesModulesEnabled = exports.VOUCHERS_AND_EVENTS_MODULES_ONLY = exports.VOUCHERS_MODULE_ONLY = exports.EVENTS_MODULE_ONLY = void 0;
exports.EVENTS_MODULE_ONLY = 'EVENTS_MODULE_ONLY';
exports.VOUCHERS_MODULE_ONLY = 'VOUCHERS_MODULE_ONLY';
exports.VOUCHERS_AND_EVENTS_MODULES_ONLY = 'VOUCHERS_AND_EVENTS_MODULES_ONLY';
const checkOnlyFulfilablesModulesEnabled = (modules) => {
    if (!modules)
        return false;
    const enabledKeys = Object.keys(modules).filter((key) => modules[key].enabled);
    const eventsEnabled = enabledKeys.includes('events');
    const vouchersEnabled = enabledKeys.includes('vouchers');
    if (enabledKeys.length === 1 && eventsEnabled) {
        return exports.EVENTS_MODULE_ONLY;
    }
    if (enabledKeys.length === 1 && vouchersEnabled) {
        return exports.VOUCHERS_MODULE_ONLY;
    }
    if (enabledKeys.length === 2 && eventsEnabled && vouchersEnabled) {
        return exports.VOUCHERS_AND_EVENTS_MODULES_ONLY;
    }
    return false;
};
exports.checkOnlyFulfilablesModulesEnabled = checkOnlyFulfilablesModulesEnabled;
